export default __webpack_public_path__ + "static/media/about-page-video.36aeb169.webm";